import { stores, fromJS, toJS, uuid } from 'core';

import { defaultLocale } from 'locale';

function getField(card, i, field, locale) {

    const { app: { get, edit } } = stores();

    edit('cards', `${i}`, `${field}`, (card.get(`${field}${locale}`) || card.get(`${field}`)));
}

function translate(card, i, locale) {

    ['title', 'description', 'fullDescription'].forEach(field =>
        card.set(field, getField(card, i, field, locale)));
}

export default function() {

    const { app: { get, edit } } = stores();

    const locale = get('locale') || defaultLocale;

    edit('global', 'backdrop', 'open', true);

    setTimeout(() => {
        get('cards').forEach((card, i) => translate(card, i, locale));
        edit('global', 'backdrop', 'open', false);
    }, 150);

    return true;
}



// WEBPACK FOOTER //
// ./app/a/cards/update.js